<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.rj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:Arial;">L-</span>
        </b>
        <b>
          <span style="font-size:18px;font-family:宋体;">Carnitine Tartrate</span>
        </b>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Commodity</span>
        </u>
        <span style="font-size:12px;font-family:Arial;">: L-Carnitine Tartrate</span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec</span>
        </u>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Appearance(Visual) :&nbsp;&nbsp;&nbsp;
          White Crystalline powder
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Assay</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≥99%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Specific Rotation</span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -9.5</span>
          <sup>
            <span style="font-size:12px;">0</span>
          </sup>
          <span style="font-size:12px;">—-11</span>
          <sup>
            <span style="font-size:12px;">0</span>
          </sup>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Water Content:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≤0.50%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Residue On Ignition</span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≤0.50%</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Particle Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 20—80 mesh</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Heavy Metals</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≤10ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Arsenic</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≤1ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Ph (1% water solution)</span>
          <span></span>
          <span style="font-size:12px;">: 3.0—4.5</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Solubility</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Clarification</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Chloride</span>
          <span></span>
          <span
            style="font-size:12px;"
          >:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ≤0.4%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">L-Carnitine Content</span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 67.2%—69.2%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          L-Tartaric Acid
          Content:30.8%—32.8%
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Packing</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">: 25kg Fiber drum</span>
          <span style="font-size:12px;">&nbsp; &nbsp;&nbsp;</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        rj: require("../../../assets/img/common/rj.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/rj.vue